<template>
  <div>
    <Nav></Nav>
    <banner-part :bannerInfo="bannerInfo"></banner-part>
    <recruit></recruit>
    <Footer class="top" />
  </div>
</template>

<script>
import BannerPart from "../components/BannerPart.vue";
import Recruit from "./components/recruit.vue";
export default {
  components: { BannerPart, Recruit },
  data() {
    return {
      bannerInfo: {
        text1: "人才招聘",
        text2: "与优秀的人一起，推动能源与交通绿色转型",
        swiperImg: require("./images/swiper.png"),
      },
    };
  },
};
</script>
